import React from "react";
import DocumentPrintPdfActions from "./DocumentPrintPdfActions";

export default function SalesContractDocumentActions({ contractId, contractNumber }) {
  const safeName = (contractNumber || `sales-contract-${contractId}`).replace(/[/\\?%*:|"<>]/g, "-");

  return (
    <DocumentPrintPdfActions
      printPath={`/sales-contracts/${contractId}/print`}
      pdfPath={`/sales-contracts/${contractId}/pdf`}
      pdfFilename={`${safeName}.pdf`}
      printTitle={`Print sales contract${contractNumber ? ` (${contractNumber})` : ""}`}
      pdfTitle={`Download sales contract PDF${contractNumber ? ` (${contractNumber})` : ""}`}
      testIdPrefix={`sales-contract-${contractNumber}`}
    />
  );
}
